// App.vue
<template>
  <div>
    <!-- Header Component -->
    <header class="bg-light py-3">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center">
          <div class="logo">
            <a class="navbar-brand" href="#">
              <!-- <span class="brand-text">Dough</span> -->
              <img src="../assets/images/dough.png" alt="Dough">
            </a>
          </div>
          <div>
            <button class="btn btn-dark text-uppercase">Work with Us</button>
          </div>
        </div>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="container my-5">
      <div class="row text-start">
        <div class="col-12 col-md-4">
          <p class="small text-uppercase" style="letter-spacing: 0.04em;"></p>
        </div>
        <div class="col-12 col-md-8">
          <h1 class="display-1 text-uppercase fw-medium lh-1">FRACTIONAL MODULAR AGENCY FOR STARTUPS</h1>
        </div>
      </div>

      <div class="row mt-3 mt-md-5 text-start">
        <div class="col-12 col-md-8">
          <img src="../assets/images/1600x780_grey_With douge.jpg" alt="We are Dough" class="img-fluid">
        </div>
        <div class="col-12 col-md-4 mt-4 mt-md-0 text-start">
          <p>We're your future agency, tackling every aspect of brand-building with precision & joy!</p>
          <p>We are not yesterday's agency with bloated cookie-cutter teams and prohibitive prices. 
            One size never fits all. So we hand-pick a lean, skilled interdisciplinary set of relevant marketing hands and minds, 
            who will be best positioned to turn your brand vision into reality.</p>
          <p class="text-dark fw-bold">Every single thing we do contributes to clearly defined brand and business goals. 
            We work best with early stage brands and businesses.</p>
          
          <!-- Social Links -->
          <div class="mt-4 text-start">
            <p class="small">Connect with us:</p>
            <div class="d-flex gap-2">
              <a href="https://www.instagram.com/dough_the_agency?igsh=OWJnbXNjZTJ6b3Aw&utm_source=qr" 
                target="_blank" class="btn btn-dark btn-sm">
                <i class="bi bi-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/105346492/admin/dashboard/" 
                target="_blank" class="btn btn-dark btn-sm">
                <i class="bi bi-linkedin"></i>
              </a>
              <!-- <a href="https://doughtheagency.substack.com/" 
                target="_blank" class="btn btn-dark btn-sm">
                <i class="bi bi-substack"></i>
              </a> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Services Section -->
    <section class="container my-5 text-start">
      <div class="row">
        <div class="col-12 col-md-4 mobile-none">
          <p class="small text-uppercase" style="letter-spacing: 0.04em;"></p>
        </div>
        <div class="col-12 col-md-8">
          <h2 class="display-5">Why a modular team</h2>
        </div>
      </div>

      <div class="row mt-5 text-start">
        <div class="col-12 col-md-4 mobile-none">
          <p class="small text-uppercase" style="letter-spacing: 0.04em;"></p>
        </div>
        <div class="col-12 col-md-4">
          <div class="mb-4">
            <h3>Scalable Brand Solutions for Growing Businesses</h3>
            <p>Brand-building is a blend of creative, communication, tech, and strategy. 
              For a growing brand, hiring full-time specialists for every role is unrealistic. 
              That's where we come in—with a flexible, scalable mix of services to create a brand that's primed to reach soaring heights. </p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="mb-4">
            <h3>On-Demand Marketing Team for Growth</h3>
            <p>Whether you're a solo founder or have a budding team, think of us as your marketing team on demand. 
              We'll manage your brand function so you can focus on what matters. If you've made a few key hires, we'll provide structure, fill skills gaps, and give your team the direction they need.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Courses Section -->
    <section class="bg-light-grey py-3 py-md-5 text-start">
      <div class="container">
        <div class="row mt-4">
          <div class="col-12 col-md-6">
            <h2 class="display-5">What we actually do</h2>
          </div>
          <div class="col-12 col-md-6 align-items-end">
            <p>We tailor our solutions to your unique needs, scaling up or down as required, whether you're a fledgling brand at day 0 or scale-up looking at growth.</p>
            <p>And we don't do it all at once. We'll execute the right services at the right time, with agility.</p>
          </div>
        </div>

        <div class="row mt-3 mt-md-5">
          <div class="col-12 col-md-6">
            <div class="card h-100">
              <div class="card-body">
                <h3>Services</h3>
                <ul>
                <li>Brand Strategy</li>
                <li>Design, Creative & Content</li>
                <li>Go-to-Market and Brand Campaigns</li>
                <li>Performance Marketing</li>
                <li>Influencer Activation</li>
                <li>In-house Capability Enablement</li>
              </ul>
              </div>
              <!-- <div class="card-footer bg-white border-0">
                <button class="btn btn-dark w-100 text-uppercase">Work with us</button>
              </div> -->
            </div>
          </div>
          
          <div class="col-12 col-md-6 mt-3 mt-md-0">
            <div class="card h-100">
              <div class="card-body">
                <h3>Road to in-housing</h3>
                <p>We leave you in good hands (your hands)</p>
                <p>Once your brand is thriving, we'll help you build an in-house marketing team to sustain your growth and confidently take your brand to the next level.</p>
              </div>
              <!-- <div class="card-footer bg-white border-0">
                <button class="btn btn-dark w-100">Start course</button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Testimonials Section -->
    <!-- <section class="bg-light py-5 mt-5">
      <div class="container">
        <p class="small text-uppercase" style="letter-spacing: 0.04em;">What folks are saying about Annalee</p>
        
        <div class="row mt-4">
          <div class="col-12 col-md-4">
            <div class="card h-100 border-0 bg-transparent">
              <div class="card-body">
                <h4>Clarity and confidence</h4>
                <p>With Annalee's coaching, I found clarity and confidence I never knew I had.</p>
                <div class="d-flex align-items-center mt-4">
                  <img src="/avatar1.jpg" alt="Kai" class="rounded-circle" style="width: 60px; height: 60px; object-fit: cover;">
                  <div class="ms-3">
                    <p class="mb-0 fw-bold">Kai Willmott</p>
                    <p class="mb-0 small">Agency founder</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          Additional testimonials would follow same pattern 
        </div>
      </div>
    </section> -->

    <!-- FAQ Section -->
    <!-- <section class="container my-5">
      <div class="row">
        <div class="col-12 col-md-4">
          <h2 class="display-5">FAQs</h2>
        </div>
        <div class="col-12 col-md-8">
          <div class="accordion" id="faqAccordion">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                  How are the coaching sessions conducted?
                </button>
              </h2>
              <div id="faq1" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                <div class="accordion-body">
                  Our coaching sessions are conducted online via secure video conferencing platforms.
                </div>
              </div>
            </div>
             Additional FAQ items would follow same pattern 
          </div>
        </div>
      </div>
    </section> --> 

    <!-- Call to Action -->
    <section class="bg-light py-4">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-9 col-md-10 text-start">
            <button class="btn btn-dark text-uppercase px-4 py-2">Work with us</button>
          </div>
          <div class="col-3 col-md-2">
            <div class="social-links d-flex gap-2 justify-content-end">
              <a 
                href="https://www.instagram.com/dough_the_agency?igsh=OWJnbXNjZTJ6b3Aw&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer" 
                class="btn btn-dark btn-sm"
                aria-label="Instagram"
              >
                <i class="bi bi-instagram"></i>
              </a>
              <a 
                href="https://www.linkedin.com/company/105346492/admin/dashboard/" 
                target="_blank" 
                rel="noopener noreferrer" 
                class="btn btn-dark btn-sm"
                aria-label="LinkedIn"
              >
                <i class="bi bi-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import { useMeta } from 'vue-meta';
// import { siteMeta } from '@/meta';

export default {
  name: 'App',
  data() {
    return {
      // Add reactive data here if needed
    }
  },
  // Add methods, computed properties, etc. as needed
}

// useMeta({
//   title: siteMeta.home.title,
//   meta: siteMeta.home.meta
// })

</script>

